import { convertQueryObjToString, localisedValue } from "utils"
import parentApi from "store/parentApi"
import todosTransformer from "./transformResponse/todosTransformer"
import { createPrivilegeObject } from "utils/privileges/privilegesMapper"

const todosApi = parentApi.injectEndpoints({
  endpoints: build => ({
    getTodos: build.query({
      query: params => {
        const { deadline, allocatedTo, assignedTo, ...rest } = params
        // TODO: fix this
        const payload = {
          ...rest,
        }

        if (!!deadline) {
          let date = deadline?.split(",")
          date = encodeURIComponent(`{"from":"${date[0]}","to":"${date[1]}"}`)
          payload.deadline = date
        }
        if (!!allocatedTo) {
          const arr = []
          const allocatedToList = allocatedTo?.split(",")
          for (let i = 0; i < allocatedToList?.length; i++) {
            arr.push(
              encodeURIComponent(
                `${i === 0 ? "[" : ""}{"id":"${allocatedToList[i]}","type":"staff"}${
                  i === allocatedToList?.length - 1 ? "]" : ""
                }`
              )
            )
          }
          payload.allocatedTo = arr
          payload.includeAllChildrenAllocatedTo = true
        }

        if (!!assignedTo) {
          let childIdentifierKey = "assignedTo_withoutChildren"
          payload.assignedTo = `{"userIds":[${assignedTo}],"includeAllChildren":${!payload?.[childIdentifierKey]}}`
        }
        delete payload["assignedTo_withoutChildren"]
        return `/todos/search?${convertQueryObjToString(payload)}`
      },
      transformResponse: response => todosTransformer(response),
      providesTags: ["todos"],
    }),
    getTodosProject: build.query({
      query: () => `todos/projects?sortOrder=asc&sortBy=name`,
      transformResponse: response =>
        response.map(e => ({ label: localisedValue({ object: e, key: "name" }), value: e?.projectId?.toString() })),
    }),
    getExpendedTodos: build.query({
      query: ids => `todos?inquiryId=${ids?.leadId}&excludeTodoId=${ids?.todoId}`,
      transformResponse: response =>
        response?.map(item => ({
          ...item,
          privileges: createPrivilegeObject(item?.privileges),
        })),
    }),
  }),
})

export const { useGetTodosQuery, useGetTodosProjectQuery, useLazyGetExpendedTodosQuery } = todosApi
